module.exports = __webpack_public_path__ + "img/50.467799d3.png";